import { render, staticRenderFns } from "./PraticeSensitiveTopicsTecSection.vue?vue&type=template&id=80583376"
import script from "./PraticeSensitiveTopicsTecSection.vue?vue&type=script&lang=ts"
export * from "./PraticeSensitiveTopicsTecSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeSensitiveTopicsTecSection.vue?vue&type=style&index=0&id=80583376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports